package ui.user.detail.permissions

import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import org.jetbrains.compose.resources.*
import ssoft.frontend.generated.resources.*
import tools.*
import ui.user.detail.*
import ui.widget.Space

@Composable
private fun CustomDivider(double: Boolean) {
    HorizontalDivider(
        thickness = 2.dp,
        color = MaterialTheme.colorScheme.surface.copy(alpha = if (double) 1F else 0.5F)
    )
}

@Composable
fun UserScope.PermissionItem(permission: UserScope.WrapperPermission, canEdit: Boolean) {
    val verticalScrollState = rememberScrollState()
    val horizontalScrollState = rememberScrollState()
    Box(
        Modifier.fillMaxSize().verticalScroll(verticalScrollState)
    ) {
        Column(Modifier.fillMaxWidth()) {
            if (permission.permissionGroups.isNotEmpty()) {
                Box(
                    Modifier.fillMaxWidth()
                        .horizontalScroll(horizontalScrollState)
                        .padding(horizontal = 8.dp)
                        .padding(top = 16.dp)
                ) {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        permission.permissionGroups.forEach {
                            Button({ it.activate() }) {
                                Text(it.label.rememberString())
                            }
                        }
                    }
                }
                Space(4.dp)
                HorizontalScrollbar(
                    adapter = rememberScrollbarAdapter(horizontalScrollState),
                    modifier = Modifier.fillMaxWidth()
                        .padding(horizontal = 8.dp)
                )
                Space(4.dp)
            }
            Card(
                modifier = Modifier.fillMaxWidth().padding(8.dp),
            ) {
                Column(Modifier.fillMaxWidth().padding(16.dp)) {

                    PermissionItemHeaders()
                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_server,
                        permissions = permission.server,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_license,
                        permissions = permission.license,
                        canEdit = canEdit
                    )

                    CustomDivider(true)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_company,
                        permissions = permission.company,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_location,
                        permissions = permission.location,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_location_emergency,
                        permissions = permission.locationEmergency,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_user,
                        permissions = permission.user,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_permissions,
                        permissions = permission.userPermission,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_resources,
                        permissions = permission.resources,
                        canEdit = canEdit
                    )
                    CustomDivider(true)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_layer_top,
                        permissions = permission.campaign,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_layer_bottom,
                        permissions = permission.deviceMode,
                        canEdit = canEdit
                    )

                    CustomDivider(true)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_device,
                        permissions = permission.deviceInfo,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_dev_display,
                        permissions = permission.deviceDisplay,
                        canEdit = canEdit
                    )

                    CustomDivider(false)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_dev_actions,
                        permissions = permission.deviceActions,
                        canEdit = canEdit
                    )

                    CustomDivider(true)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_report_system,
                        permissions = permission.reportSystem,
                        canEdit = canEdit
                    )
                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_report_layer_top,
                        permissions = permission.reportLayerTop,
                        canEdit = canEdit
                    )

                    CustomDivider(true)

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_translation,
                        permissions = permission.translation,
                        canEdit = canEdit
                    )

                    PermissionItemEntry(
                        title = Res.string.user_detail__permission_hardware,
                        permissions = permission.hardware,
                        canEdit = canEdit
                    )
                }
            }
        }
    }
}

@Suppress("UnusedReceiverParameter")
@Composable
fun UserScope.PermissionItemHeaders() {
    Row(Modifier.fillMaxWidth()) {
        Spacer(Modifier.weight(1.5F))
        Text(
            text = Res.string.user_detail__permission_type_view.rememberString(),
            textAlign = TextAlign.Center,
            modifier = Modifier.weight(1F),
            style = MaterialTheme.typography.titleMedium
        )
        Space(4.dp)
        Text(
            text = Res.string.user_detail__permission_type_add.rememberString(),
            textAlign = TextAlign.Center,
            modifier = Modifier.weight(1F),
            style = MaterialTheme.typography.titleMedium
        )
        Space(4.dp)
        Text(
            text = Res.string.user_detail__permission_type_edit.rememberString(),
            textAlign = TextAlign.Center,
            modifier = Modifier.weight(1F),
            style = MaterialTheme.typography.titleMedium
        )
        Space(4.dp)
        Text(
            text = Res.string.user_detail__permission_type_delete.rememberString(),
            textAlign = TextAlign.Center,
            modifier = Modifier.weight(1F),
            style = MaterialTheme.typography.titleMedium
        )
    }
}

@Suppress("UnusedReceiverParameter")
@Composable
fun UserScope.PermissionItemEntry(
    title: StringResource,
    permissions: UserScope.WrapperPermissionItem,
    canEdit: Boolean
) {
    Row(Modifier.fillMaxWidth()) {
        Text(
            text = title.rememberString(),
            style = MaterialTheme.typography.titleMedium,
            modifier = Modifier.weight(1.5F)
                .align(Alignment.CenterVertically)
        )
        Box(Modifier.weight(1F).align(Alignment.CenterVertically)) {
            if ((permissions.visibilityMask and permissions.maskView) > 0) {
                Checkbox(
                    modifier = Modifier.align(Alignment.Center),
                    enabled = canEdit && ((permissions.loginPermission and permissions.loginMaskView) > 0),
                    checked = permissions.view.state,
                    onCheckedChange = { permissions.view.set(it) })
            }

        }
        Box(Modifier.weight(1F).align(Alignment.CenterVertically)) {
            if ((permissions.visibilityMask and permissions.maskAdd) > 0) {
                Checkbox(
                    modifier = Modifier.align(Alignment.Center),
                    enabled = canEdit && ((permissions.loginPermission and permissions.loginMaskAdd) > 0),
                    checked = permissions.add.state,
                    onCheckedChange = { permissions.add.set(it) })
            }
        }
        Box(Modifier.weight(1F).align(Alignment.CenterVertically)) {
            if ((permissions.visibilityMask and permissions.maskEdit) > 0) {
                Checkbox(
                    modifier = Modifier.align(Alignment.Center),
                    enabled = canEdit && ((permissions.loginPermission and permissions.loginMaskEdit) > 0),
                    checked = permissions.edit.state,
                    onCheckedChange = { permissions.edit.set(it) })
            }
        }
        Box(Modifier.weight(1F).align(Alignment.CenterVertically)) {
            if ((permissions.visibilityMask and permissions.maskDelete) > 0) {
                Checkbox(
                    modifier = Modifier.align(Alignment.Center),
                    enabled = canEdit && ((permissions.loginPermission and permissions.loginMaskDelete) > 0),
                    checked = permissions.delete.state,
                    onCheckedChange = { permissions.delete.set(it) })
            }
        }
    }

}

